import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { useTheme } from 'Components/ComponentLibrary/Styles';

const Laptop = props => {
  const theme = useTheme();

  return (
    <SvgIcon viewBox="0 0 88.579 66.435" {...props}>
      <path id="Icon_ionic-md-laptop" data-name="Icon ionic-md-laptop" d="M75.662,65.4a7.4,7.4,0,0,0,7.381-7.381V11.882A7.4,7.4,0,0,0,75.662,4.5H12.918a7.4,7.4,0,0,0-7.382,7.382V58.017A7.4,7.4,0,0,0,12.918,65.4H0c0,4.06,11.072,5.536,16.609,5.536H71.971c5.536,0,16.609-1.476,16.609-5.536ZM12.918,11.882H75.662V58.939H12.918ZM44.29,68.628a3.691,3.691,0,1,1,3.691-3.691A3.7,3.7,0,0,1,44.29,68.628Z" transform="translate(0 -4.5)" fill={theme.palette.primary.main} />
    </SvgIcon>
  );
};

export default Laptop;
